import { ReferenceInput, SelectInput } from "ra-ui-materialui";

import React from "react";
import { get } from "lodash";
import { useTranslate } from "ra-core";

const optionText = (translate, option) =>
  option.type === "added"
    ? translate("ra.option.added", { name: option.title })
    : option.full_title;
const WorkPackageInput = ({ helperText, ...props }) => {
  const executiveProjectId = get(props, "record.executive_project_id");
  const translate = useTranslate();
  return (
    <ReferenceInput
      {...props}
      reference="executive-project-work-packages"
      sort={{ field: "order_index", direction: "ASC" }}
      filter={{
        executive_project_id: executiveProjectId,
      }}
    >
      <SelectInput
        optionText={optionText.bind(this, translate)}
        helperText={helperText}
      />
    </ReferenceInput>
  );
};
export default WorkPackageInput;
